import { CameraDetail } from '@hakimo-ui/hakimo/types';
import { DetailSection, Label } from '@hakimo-ui/shared/ui-base';

interface Props {
  camera: CameraDetail;
}

export function SettingSectionAudioDevices(props: Props) {
  const { camera } = props;
  const audioDeviceAvailable =
    camera.audioDeviceMapped &&
    camera.audioDevices &&
    camera.audioDevices.length > 0;
  return (
    <DetailSection title="Associated Audio Devices">
      {audioDeviceAvailable ? (
        <ul>
          {camera.audioDevices?.map((audioDevice) => (
            <li
              key={audioDevice.id}
              className="flex items-center gap-6 space-x-4 py-4"
            >
              <div className="flex items-center gap-x-3">
                <div className="dark:text-ondark-text-2 text-onlight-text-3 flex-none rounded-full p-1">
                  <div className="h-2 w-2 rounded-full bg-current"></div>
                </div>
                <h2 className="min-w-0 text-sm font-semibold leading-6">
                  {audioDevice.url}
                </h2>
              </div>
              <Label type="info">{audioDevice.deviceType}</Label>
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-onlight-text-2 dark:text-ondark-text-2 py-4 text-sm">
          No current audio device integration.
        </div>
      )}
    </DetailSection>
  );
}

export default SettingSectionAudioDevices;
